import { updateMortgageProductHelper } from '../api/mortgage_product'
import { associateMortgageWithProductCP } from '../api_client_portal/mortgage'
import { createMortgageProductCP, deleteMortgageProductCP } from '../api_client_portal/product'
import type { Resolvers } from '../generated/server/resolvers'

const ProductResolver: Resolvers = {
  Mutation: {
    updateMortgageProductCp: async (_parent, { mortgageId, mortgageProductId, mortgageProductInput }) => {
      const newMortgageProduct = await createMortgageProductCP(mortgageProductInput)
      await deleteMortgageProductCP(mortgageId, mortgageProductId)
      // Link mortgage and new product
      await associateMortgageWithProductCP({ product_id: newMortgageProduct.product_id, mortgage_id: mortgageId })
      return newMortgageProduct
    },
    updateMortgageProduct: async (_parent, { mortgageId, mortgageProductId, mortgageProductInput, mortgageInput }) => {
      const mortgage = await updateMortgageProductHelper(
        mortgageId,
        mortgageProductId,
        mortgageProductInput,
        mortgageInput,
      )

      return mortgage
    },
  },
}

export default ProductResolver
